<ng-container>
  <div
    class="tw-flex tw-flex-col tw-min-h-[calc(100%-16px)] tw-m-2 tw-pt-2 tw-text-center tw-text-[16px] tw-font-montserrat tw-font-medium tw-text-dt-text-headings tw-whitespace-nowrap tw-bg-glass-panel tw-backdrop-blur-[20px] tw-border tw-border-white/60 dark:tw-border-white/[0.18] tw-rounded-20 tw-shadow-[4px_6px_14px_0px_rgba(0,0,0,0.08),0px_6px_7px_0px_rgba(255,255,255,0.4)] dark:tw-shadow-[inset_0px_1px_1.5px_0px_rgba(255,255,255,0.08)] dark:tw-drop-shadow-[0px_6px_7px_rgba(0,0,0,0.5)]"
  >
    <img
      class="tw-my-3 tw-w-[65%] tw-mx-auto"
      alt="Gloss Logo"
      src="../../../../images/icons/gloss-logo.png"
    />

    <!-- One nav landmark for the menu; each item is a real link so Enter activates it (a
         routerLink on a non-link element is focusable but ignores the keyboard). -->
    <nav
      data-primary-nav="vertical"
      class="tw-flex tw-flex-col tw-whitespace-nowrap tw-px-4 tw-pb-2 tw-gap-2"
      [attr.aria-label]="'primaryNavigation' | i18n"
    >
      @for (item of navItems; track item.key; let index = $index) {
        <ng-container *appRoleScope="item.roleScope">
          @if (isSignal(item)) {
            <app-signal-glow-wrapper
              class="tw-z-10"
              [adjustmentClasses]="'tw-mx-3 tw-px-6 tw-py-4 tw-rounded-xl'"
              [isSignal]="isSignal(item)"
            >
              <ng-container
                *ngTemplateOutlet="
                  sidebarNav;
                  context: { item: item, onIsActiveChange: onIsActiveChange }
                "
              ></ng-container>
            </app-signal-glow-wrapper>
          } @else {
            <ng-container
              *ngTemplateOutlet="
                sidebarNav;
                context: { item: item, onIsActiveChange: onIsActiveChange }
              "
            ></ng-container>
          }
        </ng-container>

        <!-- Divider after accounts (index 2: home, rewards, accounts) -->
        @if (index === 2) {
          <div class="tw-my-2 tw-flex tw-h-[2px] tw-w-full tw-flex-col">
            <div class="tw-h-px tw-w-full tw-bg-white/[0.82] dark:tw-bg-white/[0.05]"></div>
            <div class="tw-h-px tw-w-full tw-bg-black/[0.1] dark:tw-bg-black/[0.42]"></div>
          </div>
        }

        <!-- Divider before settings -->
        @if (navItems[index + 1]?.key === GlossRoutes.Settings) {
          <div class="tw-my-2 tw-flex tw-h-[2px] tw-w-full tw-flex-col">
            <div class="tw-h-px tw-w-full tw-bg-white/[0.82] dark:tw-bg-white/[0.05]"></div>
            <div class="tw-h-px tw-w-full tw-bg-black/[0.1] dark:tw-bg-black/[0.42]"></div>
          </div>
        }
      }
    </nav>

    <!-- Fixed footer action, not part of the reorderable navItems list — pinned to the bottom
         of the panel. Gated on the Settings NavItem's roleScope (a user who can't see Settings
         shouldn't see this either) and on the plugin's own enabled flag — a user who has
         toggled Monthly Summary off shouldn't see an ungated path to the dialog. Mirrors
         more-overview.component.html for mobile. -->
    @if (monthlySummaryEnabled()) {
      <ng-container *appRoleScope="settingsRoleScope">
        <button
          type="button"
          class="tw-mt-auto tw-flex tw-h-[48px] tw-w-full tw-items-center tw-gap-2 tw-pl-[29px] tw-pr-4 tw-py-[14px] tw-rounded-b-[19px] tw-border-0 tw-bg-color-surface-card tw-text-left tw-text-[16px] tw-font-medium tw-leading-none tw-tracking-normal tw-font-montserrat tw-text-dt-text-secondary tw-cursor-pointer tw-transition-colors hover:tw-bg-color-surface-elevated focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:-tw-outline-offset-2 focus-visible:tw-outline-color-action-primary"
          (click)="openMonthlySummary()"
          [attr.data-testid]="'side-menu-monthly-summary'"
        >
          <svg class="tw-h-6 tw-w-6 tw-shrink-0 tw-text-dt-text-tertiary" aria-hidden="true">
            <use xlink:href="images/sprite.svg#bar-chart-line" />
          </svg>
          <span class="tw-min-w-0 tw-whitespace-nowrap">{{ "monthlySummary" | i18n }}</span>
        </button>
      </ng-container>
    }
  </div>
</ng-container>

<ng-template #sidebarNav let-item="item">
  <a
    [class]="navRowClass + ' hover:tw-no-underline'"
    [routerLink]="item.routerLink"
    ariaCurrentWhenActive="page"
    [routerLinkActive]="[
      'tw-bg-white/40',
      'dark:tw-bg-white/[0.06]',
      'tw-border-white/60',
      'dark:tw-border-white/[0.18]',
      'tw-shadow-[-2px_-2px_4px_0px_rgba(255,255,255,0.72),2px_2px_4px_0px_rgba(0,0,0,0.14)]',
      'dark:tw-shadow-[-2px_-2px_4px_0px_rgba(255,255,255,0.04),2px_2px_4px_0px_rgba(0,0,0,0.5)]',
    ]"
    (isActiveChange)="onIsActiveChange($event, item.key)"
    [attr.data-testid]="'side-menu-' + item.key"
  >
    <ng-container
      *ngTemplateOutlet="
        navRowContent;
        context: {
          iconHref: getSelectedIcon(item),
          label: item.label | i18n,
          isActive: selectedKey() === item.key,
        }
      "
    ></ng-container>
  </a>
</ng-template>

<ng-template #navRowContent let-iconHref="iconHref" let-label="label" let-isActive="isActive">
  <svg
    class="tw-h-6 tw-w-6 tw-shrink-0"
    [ngClass]="isActive ? 'tw-text-dt-text-action' : 'tw-text-dt-text-tertiary'"
  >
    <use [attr.xlink:href]="'images/sprite.svg#' + iconHref" />
  </svg>
  <span
    [ngClass]="
      isActive
        ? 'tw-font-semibold tw-text-dt-text-action'
        : 'tw-font-medium tw-text-dt-text-secondary'
    "
    class="tw-min-w-0 tw-truncate"
    [title]="label"
    >{{ label }}</span
  >
</ng-template>
